import React from 'react';
import LandingMinimalHeader from '../components/landing/LandingMinimalHeader';
import SiteFooter from '../components/shared/SiteFooter';
import '../pages/Landing.css';
import '../components/Quiz/Quiz.css';

/**
 * Shared dark shell for /quiz and related public routes.
 */
const TraderQuizShell = ({ children }) => {
  return (
    <div
      className="trader-quiz-page d-flex flex-column min-vh-100 overflow-x-hidden"
      data-bs-theme="dark"
      style={{ background: 'var(--bg-primary, #0a0d14)' }}
    >
      <LandingMinimalHeader brandPathname="/home" />
      <main className="flex-grow-1 w-100">{children}</main>
      <SiteFooter containerClass="quiz-site-footer-container" showRiskDisclaimer />
    </div>
  );
};

export default TraderQuizShell;
